import FormDepositCreate from './FormDepositCreate';
import FormDepositDelete from './FormDepositDelete';
import FormDepositFilter from './FormDepositFilter';
import FormDepositUpdate from './FormDepositUpdate';
import FormDepositUpdateMany from './FormDepositUpdateMany';

export default Object.assign(
  {},
  {
    Create: FormDepositCreate,
    Update: FormDepositUpdate,
    Filter: FormDepositFilter,
    Delete: FormDepositDelete,
    UpdateMany: FormDepositUpdateMany,
  },
);
